import { render, staticRenderFns } from "./avatar-da-conversa.vue?vue&type=template&id=5bc62af4&scoped=true&"
import script from "./avatar-da-conversa.vue?vue&type=script&lang=js&"
export * from "./avatar-da-conversa.vue?vue&type=script&lang=js&"
import style0 from "./avatar-da-conversa.vue?vue&type=style&index=0&id=5bc62af4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc62af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc62af4')) {
      api.createRecord('5bc62af4', component.options)
    } else {
      api.reload('5bc62af4', component.options)
    }
    module.hot.accept("./avatar-da-conversa.vue?vue&type=template&id=5bc62af4&scoped=true&", function () {
      api.rerender('5bc62af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/avatar-da-conversa/avatar-da-conversa.vue"
export default component.exports